import DeletedProduct from "./DeletedProduct";

export default DeletedProduct;
